import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Descriptions, Row, Space, Image, Tag, Tooltip } from "antd";
import { ReactComponent as PersonSvg } from "../../../assets/images/description/person.svg";
import { ReactComponent as AboutSvg } from "../../../assets/images/description/Notes.svg";
import { ReactComponent as HomeSvg } from "../../../assets/images/description/home.svg";
import { ReactComponent as CategorySvg } from "../../../assets/images/description/category.svg";
import { ReactComponent as PodcastSvg } from "../../../assets/images/description/Mic.svg";
import { Link, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getPodcastDetailsData } from "../../../redux/action/podcast/podcastAction";
import BackArrowImg from "../../../assets/images/arrowLeft.png";
import { ReactComponent as CalenderSvg } from "../../../assets/images/description/calendar.svg";
import dayjs from "dayjs";

const ViewPodcast = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const audioRef = useRef(null);

  const data = useSelector((store) => store.getPodcastDetailsData?.data);
  const { isLoading } = useSelector((store) => store.getPodcastDetailsData);

  useEffect(() => {
    if (params?.id) {
      dispatch(getPodcastDetailsData(params.id));
    }
  }, [params?.id, dispatch]);

  const basicInfo_details = [
    {
      key: "1",
      label: (
        <>
          <PodcastSvg /> Podcast Title
        </>
      ),
      children: data?.title_en ?? data?.title_es ?? data?.title_pt ?? "N/A",
      span: 2,
    },
    // {
    //   key: "2",
    //   label: (
    //     <>
    //       <PersonSvg /> Author Name
    //     </>
    //   ),
    //   children: data?.author_name_en ?? "N/A",
    //   span: 2,
    // },
    {
      key: "3",
      label: (
        <>
          <CategorySvg /> Podcast Category
        </>
      ),
      children: (
        <>
          <div className="tag-wrapper">
            {data?.PodcastCategories?.map((item, index) => {
              return item?.name_en.length > 10 ? (
                <Tooltip key={index} title={item?.name_en}>
                  <Tag color="#00bcd4" className="tag-round">
                    {item?.name_en}
                  </Tag>
                </Tooltip>
              ) : (
                <Tag key={index} color="#00bcd4" className="tag-round">
                  {item?.name_en}
                </Tag>
              );
            })}
          </div>
        </>
      ),
      span: 2,
    },
    {
      key: "4",
      label: (
        <>
          <HomeSvg /> Home Category (Optional)
        </>
      ),
      children: (
        <>
          <div className="tag-wrapper">
            {data?.HomeCategoryTags?.map((item, index) => {
              return item?.name_en.length > 10 ? (
                <Tooltip key={index} title={item?.name_en}>
                  <Tag color="#00bcd4" className="tag-round">
                    {item?.name_en}
                  </Tag>
                </Tooltip>
              ) : (
                <Tag key={index} color="#00bcd4" className="tag-round">
                  {item?.name_en}
                </Tag>
              );
            })}
          </div>
        </>
      ),
      span: 2,
    },
    {
      key: "5",
      label: (
        <>
          <CalenderSvg /> Added To
        </>
      ),
      children: data?.created_at
        ? dayjs(data?.created_at).format("MM-DD-YYYY")
        : "N/A",
      span: 2,
    },
    {
      key: "6",
    
      label: (
        <>
          <PersonSvg /> Picked by Celebrity
        </>
      ),
      children: (
        <>
          <div className="tag-wrapper">
            {data?.CelebrityMasters?.map((item, index) => {
              return item?.name_en.length > 10 ? (
                <Tooltip key={index} title={item?.name_en}>
                  <Tag color="#00bcd4" className="tag-round">
                    {item?.name_en}
                  </Tag>
                </Tooltip>
              ) : (
                <Tag key={index} color="#00bcd4" className="tag-round">
                  {item?.name_en}
                </Tag>
              );
            })}
          </div>
        </>
      ),
      span: 4,
    },
    {
      key: "7",
      label: (
        <>
          <AboutSvg /> Short Description (Max 200 Words)
        </>
      ),
      children: data?.short_desc_en ?? data?.short_desc_es ?? data?.short_desc_pt ?? "N/A",
      span: 4,
    },
    {
      key: "8",
      label: (
        <>
          <AboutSvg /> Long Description (Max 500 Words)
        </>
      ),
      children: data?.desc_en ?? data?.desc_es ?? data?.desc_pt ?? "N/A",
      // span: 1,
    },

  ];

  const viewPodcastData = {}

  const author_details = [
    {
      key: "1",
      label: (
        <>
          <PersonSvg /> Name
        </>
      ),
      children: data?.AuthorMaster?.name ?? "N/A",
      span: 1,
    },
    {
      key: "1",
      label: (
        <>
          <PersonSvg /> Status
        </>
      ),
      children:
      data?.AuthorMaster?.status == 1
          ? "Active"
          : "Inactive" ?? "N/A",
      span: 1,
    },
    {
      key: "1",
      label: (
        <>
          <PersonSvg /> Image
        </>
      ),
      children: data?.AuthorMaster?.image_url ? (
        <img
          src={`${process.env.REACT_APP_API_IMG_URI}/${data?.AuthorMaster?.image_url}`}
          alt="Author"
          style={{
            width: "80px",
            height: "80px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
      ) : (
        "N/A"
      ),
      span: 1,
    },
    {
      key: "1",
      label: (
        <>
          <AboutSvg /> About
        </>
      ),
      children: data?.AuthorMaster?.about_en ?? data?.AuthorMaster?.about_es ?? data?.AuthorMaster?.about_pt ?? "N/A",
      span: 4,
    },
  ];

  return (
    <>
      {/* Header Section */}
      <div className="customDescription">
        <div className="viewTenant">
          <div
            className="backToLogin mt-3"
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer" }}
          >
            <img src={BackArrowImg} alt="BackArrowImg" />
            <div className="tableHeading">View Podcast Details</div>
          </div>
        </div>

        {/* Main Content */}
        <Card loading={isLoading}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={16}>
              <Descriptions
                className="custom_descriptions"
                layout="vertical"
                items={basicInfo_details}
                size="small"
                column={{ xs: 1, sm: 2, md: 2 }}
              />
               <div className="tableHeading">Author Details</div>
              <Descriptions
                className="custom_descriptions"
                layout="vertical"
                items={author_details}
                size="small"
                column={{ xs: 1, sm: 2, md: 2 }}
              />
            
            </Col>
           

            <Col xs={24} md={8} className="podcast-image-container">
              <div onContextMenu={(e) => e.preventDefault()}>
                <Image
                  src={`${process.env.REACT_APP_API_IMG_URI}/${data?.book_cover_en ?? data?.book_cover_es ?? data?.book_cover_pt}`}
                  alt="Podcast"
                  className="podcast-cover-image"
                  onContextMenu={(e) => e.preventDefault()}
                  onDragStart={(e) => e.preventDefault()}
                />
              </div>
              <div className="podcast-audio">
                <audio ref={audioRef} controls controlsList="nodownload">
                  <source
                    src={`${process.env.REACT_APP_API_IMG_URI}/${data?.file_url_en ?? data?.file_url_es ?? data?.file_url_pt}`}
                    type="audio/mp3"
                  />
                  Your browser does not support the audio tag.
                </audio>
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    </>
  );
};

export default ViewPodcast;
